var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8V10.543C6.47266 16.0898 19.7109 27.4297 20.8242 28.3164C22.2148 29.5078 23.6055 29.5977 24 29.5977C24.3945 29.5977 25.7891 29.5078 27.1484 28.3398C28.207 27.4961 40.6758 16.7734 48 10.4727V8H0ZM48 13.1094C43.5156 16.9688 37.6758 21.9883 33.5312 25.5391L31.9844 26.8633C30.082 28.4922 28.7461 29.625 28.4219 29.8789C26.6172 31.4297 24.7266 31.5977 24 31.5977C23.2734 31.5977 21.3828 31.4297 19.5469 29.8594C19.2227 29.5977 4.17578 16.7539 0 13.1758V42H30.2031C31.1289 46.5586 35.1719 50 40 50C45.5156 50 50 45.5156 50 40C50 37.7578 49.25 35.6953 48 34.0273V13.1094ZM40 32C41.2734 32.0156 42.4336 32.3047 43.4492 32.793C43.4492 32.793 43.4492 32.793 43.4531 32.7969C45.6797 33.8672 47.2148 35.8945 47.7539 38.0781C47.9102 38.6953 48 39.3359 48 40C48 44.4102 44.4102 48 40 48C36.2812 48 33.1562 45.4453 32.2656 42C32.1875 41.6992 32.125 41.3867 32.0781 41.0742C32.0742 41.0469 32.0703 41.0195 32.0664 40.9883C32.0234 40.6641 32 40.3359 32 40C32 39.7461 32.0156 39.4922 32.0352 39.2461C32.4023 35.5664 35.4062 32.0898 40 32ZM44.25 35.3438L38.8438 41.625L35.5938 39.1875L34.4062 40.8125L39.1562 44.375L39.75 43.6562L45.75 36.6562L44.25 35.3438Z",
    fill: "#29CC8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceived);
export default __webpack_public_path__ + "static/media/Received.2d4508ef39f5477172d5050a55c22539.svg";
export { ForwardRef as ReactComponent };